import { IUser } from 'app/services/user';

export const userSearchFilter = (search: string, list: IUser[]) => {
  const needle = search.toLowerCase().trim();
  return list.filter((u) => {
    const fullName =
      u.given_name.toLowerCase() + ' ' + u.family_name.toLowerCase();

    return fullName.includes(needle) || u.email?.toLowerCase().includes(needle);
  });
};
